export default __webpack_public_path__ + "static/media/wheel.a67327f3.webp";